import { PropsWithChildren } from 'react';
import { TooltipIcon } from '../../common/components/Icon';
import { ExternalLink } from '../../common/components/Link';
import useIntercomArticle from '../hooks/useIntercomArticle';

type IntercomArticleLinkProps = PropsWithChildren<{
  href: string;
  onClick?: () => void; // optional extra functionality
}>;

export default function IntercomArticleLink({
  href,
  onClick,
  children,
  ...props
}: IntercomArticleLinkProps) {
  const openIntercomArticle = useIntercomArticle();

  return (
    <ExternalLink
      href={href}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        if (onClick) onClick();
        openIntercomArticle(href);
      }}
      {...props}
    >
      {children}
    </ExternalLink>
  );
}

type IntercomArticleIconLinkProps = {
  url: string;
  title: string;
  id?: string;
};

export function IntercomArticleIconLink({ url, title, ...props }: IntercomArticleIconLinkProps) {
  return (
    <IntercomArticleLink href={url} {...props}>
      <TooltipIcon title={title} />
    </IntercomArticleLink>
  );
}
